export var IValidateParamsConstans;
(function (IValidateParamsConstans) {
    IValidateParamsConstans["Trading_Nomination"] = "Trading Nomination";
    IValidateParamsConstans["Last_Income_Date"] = "Last Income Date";
    IValidateParamsConstans["Dormant_Duration"] = "Dormant Duration";
    IValidateParamsConstans["Dormant_Date"] = "Dormant Date";
    IValidateParamsConstans["Income_Range"] = "IncomeRange";
    IValidateParamsConstans["CKYC_No"] = "CKYCNo";
    IValidateParamsConstans["Email"] = "Email";
    IValidateParamsConstans["Mobile"] = "Mobile";
    IValidateParamsConstans["Client_DOB"] = "ClientDOB";
    IValidateParamsConstans["FATCA"] = "FATCA";
    IValidateParamsConstans["DP_Account_No"] = "DPAccountNo";
    IValidateParamsConstans["DP_Nomination"] = "DP Nomination";
    IValidateParamsConstans["Bank_Account_No"] = "BankAccountNo";
    IValidateParamsConstans["Bank"] = "Bank";
    IValidateParamsConstans["IFSC"] = "IFSC";
    IValidateParamsConstans["Memorandum"] = "Memorandum";
    IValidateParamsConstans["KRA"] = "KRA";
    IValidateParamsConstans["PAN_Status"] = "PAN Status";
    IValidateParamsConstans["AML"] = "AML";
    IValidateParamsConstans["PANNO"] = "PANNO";
    IValidateParamsConstans["RM"] = "RM";
    IValidateParamsConstans["Photo"] = "Photo";
    IValidateParamsConstans["Signature"] = "Signature";
    IValidateParamsConstans["Compliance_Initiated"] = "Compliance initiated";
    IValidateParamsConstans["Client_Name"] = "Client Name";
})(IValidateParamsConstans || (IValidateParamsConstans = {}));
